/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Chair/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Chair({
  children,
  viewPath = "/App/Account/WaitingRoom/Content/Content/Waiting/Appointments/Content/Appointment/Chair"
  
}) {
let appointmentBookingChairCodeValueData = fromData.useDataValue({ viewPath,
context: 'appointment_booking',
path: 'chair_code',
})
let dtColorsNeutral700 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.700'
        })
  return (<React.Fragment
>
<div
  data-testid="Chair.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="small"
 weight="semibold"
 color={dtColorsNeutral700}
 cursor="pointer"
 whiteSpace="nowrap"
 data="appointment_booking.chair_code"
 text={appointmentBookingChairCodeValueData}
/>
</div>
{children}
</React.Fragment>)
}